module.exports = __webpack_public_path__ + "static/media/S (30).137c0732.jpg";